module.exports = __webpack_public_path__ + "img/RupiahFileIcon.4b4eac1e.svg";